import appConfig from '@/appConfig';

const getConfig = () => appConfig;

export default getConfig;
